import { gql, QueryResult, useQuery } from '@apollo/client'
import type {
  GetFeaturedVideosQuery,
  GetFeaturedVideosQueryVariables,
} from 'apollo-gql'
import featuredVideosFragment from 'graphql/fragments/featuredVideosFragment'
import { currentMarketIdVar } from 'graphql/reactive'

export const GET_FEATURED_VIDEOS = gql`
  query GetFeaturedVideos($marketId: ID!, $slug: String!) {
    market(id: $marketId) {
      id
      profile(slug: $slug) {
        id
        name
        slug
        title
        ...featuredVideosFragment
      }
    }
  }
  ${featuredVideosFragment}
`
type UseFeaturedVideosReturn = {
  profile: GetFeaturedVideosQuery['market']['profile']
  featuredVideos: GetFeaturedVideosQuery['market']['profile']['featuredVideos']
} & Pick<
  QueryResult<GetFeaturedVideosQuery, GetFeaturedVideosQueryVariables>,
  'loading' | 'error'
>

const useFeaturedVideos = (slug: string): UseFeaturedVideosReturn => {
  const marketId = currentMarketIdVar()

  const { loading, data, error } = useQuery<
    GetFeaturedVideosQuery,
    GetFeaturedVideosQueryVariables
  >(GET_FEATURED_VIDEOS, {
    variables: {
      marketId,
      slug,
    },
  })

  const profile = data?.market?.profile
  const featuredVideos = profile?.featuredVideos

  return { loading, error, featuredVideos, profile }
}
export default useFeaturedVideos
